export default __webpack_public_path__ + "static/media/ihpp_map_MRT.d58fb177.jpeg";